type Localized_ = Omit<Localized, "current">

interface Story {
  name: Localized_
  location: Localized_
  text: Localized_
  photo: string
}

const IMG_BASE = "/img/wyf/stories"

export const WYF_STORIES: Story[] = [
  {
    name: {
      ru: "Леся Погорелова",
      en: "Lesya Pogorelova",
    },
    location: {
      ru: "Россия, Москва",
      en: "Russia, Moscow",
    },
    text: {
      ru: "Эмоции во время Фестиваля поистине незабываемые: встречи, знакомства, переживания! Я увезла с собой множество впечатлений, которые останутся со мной навсегда. Благодарю судьбу за шанс побывать в другом мире, а также организаторов за самое яркое событие в этом году!'",
      en: "The emotions during the Festival were truly unforgettable: meetings, new friends, excitement! I got many impressions that will stay with me forever. I thank fate for the chance to visit a different world, and the organizers for the most vivid event of the year!",
    },
    photo: `${IMG_BASE}/lesya-pogorelova.webp`,
  },
  {
    name: {
      ru: "Юсмар Майорга",
      en: "Yusmar Mayorga",
    },
    location: {
      ru: "Венесуэла",
      en: "Venezuela",
    },
    text: {
      ru: "Одним из самых значительных результатов моего участия в ВФМ стало знакомство и установление дружеских отношений с огромным количеством замечательных людей. Радует, что даже спустя 5 месяцев после Фестиваля мы сохраняем связь с участниками со всего мира, чувствуя себя частью одной большой международной семьи.",
      en: "One of the most significant results of my participation in the WYF was meeting and becoming friends with lots of great people. I am happy that even 5 months later we keep in touch with participants from across the world and feel our belonging to a single big international family.",
    },
    photo: `${IMG_BASE}/yusmar-mayorga.webp`,
  },
  {
    name: {
      ru: "Егор Головин",
      en: "Egor Golovin",
    },
    location: {
      ru: "Россия, Курская область",
      en: "Russia, Kursk Region",
    },
    text: {
      ru: "Во время проведения Фестиваля мы разработали иммерсивный квест «Погружение в Атом», а уже 18 мая в Москве мы организовали научную игру для 100 участников выставки «Россия». Это был потрясающий опыт! Впереди нас ждёт ещё больше научных проектов, квестов и мероприятий, и всё это благодаря ВФМ.",
      en: "During the Festival, we came up with an immersive quest “Immersion into Atom” and as early as on May 18 in Moscow we organized a science game for 100 participants of the Russia Expo. It was an amazing experience! Going forward, we’ll have even more scientific projects, quests and events, and all this was made possible thanks to the WYF.",
    },
    photo: `${IMG_BASE}/egor-golovin.webp`,
  },
  {
    name: {
      ru: "Дональдо Жан",
      en: "Donaldo Jean",
    },
    location: {
      ru: "Китай",
      en: "China",
    },
    text: {
      ru: "Участие во Всемирном фестивале молодёжи стало для меня настоящим волшебством. Я встретил людей из разных стран и познакомился с удивительными личностями – это был поистине уникальный опыт!",
      en: "My participation in the World Youth Festival felt really magical to me. I met people from different countries and got to know fascinating personalities. It truly was a unique experience!",
    },
    photo: `${IMG_BASE}/donaldo-jean.webp`,
  },
  {
    name: {
      ru: "Арина Терентьева",
      en: "Arina Terentyeva",
    },
    location: {
      ru: "Россия, Республика Крым",
      en: "Russia, Republic of Crimea",
    },
    text: {
      ru: "Всемирный фестиваль молодёжи стал для меня не только удивительным опытом, но и настоящим стимулом для новых достижений. В настоящее время я готовлю к запуску несколько научных проектов, которые будут способствовать развитию знаний о праве и этике среди молодёжи. Кроме того, у меня появилась возможность участвовать в международных конференциях и семинарах онлайн, где я могу делиться своим опытом и учиться у других лидеров мнений.",
      en: "For me, the World Youth Festival was not only a unique experience, but also a real motivation for new achievements. These days, I am finalizing some scientific projects that will contribute to the promotion of knowledge on law and ethics among young people. Moreover, I got an opportunity to participate in international conferences and seminars online, where I can share my experience and learn from other opinion leaders.",
    },
    photo: `${IMG_BASE}/arina-teretyeva.webp`,
  },
  {
    name: {
      ru: "Набиль Белкасс",
      en: "Nabil Belkass",
    },
    location: {
      ru: "Марокко",
      en: "Morocco",
    },
    text: {
      ru: "Всемирный фестиваль молодёжи стал поворотным моментом в моей жизни. Мы установили новые контакты, заключили множество соглашений и начали новую эру международного сотрудничества. То, что начиналось как небольшая мечта, превратилось в большую реальность!",
      en: "The World Youth Festival was a turning point in my life. We established new contacts, concluded many agreements and started a new era of international cooperation. What started out as a little dream turned out to be a big reality!",
    },
    photo: `${IMG_BASE}/nabil-belkass.webp`,
  },
  {
    name: {
      ru: "Алфер Унамо",
      en: "Alfer Unamo",
    },
    location: {
      ru: "Венесуэла",
      en: "Venezuela",
    },
    text: {
      ru: "Этот потрясающий Фестиваль предоставил мне шанс завести новых друзей и представить будущее, построенное на объединении великих идей. Он вдохновил меня поверить в то, что новое поколение молодых людей способно создать мир, где инновации основаны на семейных ценностях, мире, суверенитете и взаимной поддержке.",
      en: "This incredible Festival gave me a chance to make new friends and create a vision of a future based on a synergy of great ideas. It inspired me to believe that the new generation of young people are capable of shaping a world where innovation is based on family values, sovereignty and mutual support.",
    },
    photo: `${IMG_BASE}/alfer-unamo.webp`,
  },
  {
    name: {
      ru: "Хоссейн Сагар",
      en: "Hossain Mohammad Sagar",
    },
    location: {
      ru: "Бангладеш",
      en: "Bangladesh",
    },
    text: {
      ru: "ВФМ предоставил мне возможности, о которых я даже не мечтал. Благодаря ему я смог выступить в роли международного наблюдателя на выборах в России, что стало значительным достижением для молодого журналиста, как я. Этот фестиваль не только расширил мои горизонты, но и позволил взять на себя важные глобальные роли, открыв новые перспективы в моей профессиональной карьере и вдохновив на дальнейшее развитие.",
      en: "The WYF gave me the opportunities I’d never even dreamt of. It allowed me to act as an international observer during Russian elections which was a significant achievement for a young journalist like me. Not only did this Festival broaden my horizons, but also allowed me to take on important global roles, having opened new prospects in my professional career and having inspired further development.",
    },
    photo: `${IMG_BASE}/hossain-mohammad-sagar.webp`,
  },
  {
    name: {
      ru: "Валерия Сугак",
      en: "Valeria Sugak",
    },
    location: {
      ru: "Россия, Казань",
      en: "Russia, Kazan",
    },
    text: {
      ru: "ВФМ для меня является не только площадкой для установления новых связей, но и частью семейного наследия. Моя бабушка, будучи студенткой ветеринарной академии, благодаря своим успехам в учебе и спорте стала участницей Всемирного фестиваля молодёжи и студентов 1957 года. Поэтому для меня большая честь стать волонтёром ВФМ-2024 и внести свой вклад в значимую историю нашей семьи.",
      en: "For me, the WYF is not only a platform for new connections, but also part of my family legacy. When my grandmother was a veterinary student, her great academic performance allowed her to participate in the World Festival of Youth and Students 1957. That’s why it’s a big honor for me to be a WYF-2024 volunteer and make my contribution to our family’s important history.",
    },
    photo: `${IMG_BASE}/valeriya-sugak.webp`,
  },
  {
    name: {
      ru: "Чэн Чан",
      en: "Cheng Chang",
    },
    location: {
      ru: "Китай",
      en: "China",
    },
    text: {
      ru: "ВФМ привёл меня к тем сферам жизни, с которыми я никогда прежде не сталкивалась. Мы поддерживаем связь с другими участниками Фестиваля и даже сделали несколько совместных проектов. Например, проекты в области искусства и туризма в Перу, образовательные, бизнес и художественные проекты в России, а также проекты по молодёжному обмену в Узбекистане.",
      en: "The WYF introduced me to those spheres of life that I’d never previously dealt with. We keep in touch with other Festival participants and even created a few joint projects. For example, the projects on art and tourism in Peru, educational, business and artistic projects in Russia, as well as youth exchange projects in Uzbekistan.",
    },
    photo: `${IMG_BASE}/cheng-chang.webp`,
  },
  {
    name: {
      ru: "Татьяна Пэк",
      en: "Tatiana Peck",
    },
    location: {
      ru: "Россия, Астраханская область",
      en: "Russia, Astrakhan Region",
    },
    text: {
      ru: "После Фестиваля я поняла, что в жизни всё только начинается и ВФМ дал мне большой толчок для личностного роста. Я стала больше общаться с молодежью, придумала проект «Театры, как и рукописи, не горят». Также я разработала лекцию «История летнего театра сада Аркадия» и выступала с ней в библиотеке им. Крупской, а также сотрудничаю с проектом «Музей деревянного зодчества.",
      en: "After the Festival, I realized that my life is only beginning and the WYF had given me a big push for personal growth. I started communicating with young people more, came up with the “Theatres, like manuscripts, don’t burn” project. Moreover, I created the “History of the Summer Theatre in the Arcadia Garden” lecture and gave it at the Krupskaya Library. I also cooperate with the “Museum of Wooden Architecture” project.",
    },
    photo: `${IMG_BASE}/tatyana-pek.webp`,
  },
  {
    name: {
      ru: "Дарья Гуськова",
      en: "Daria Guskova",
    },
    location: {
      ru: "Россия, Москва",
      en: "Russia, Moscow",
    },
    text: {
      ru: "ВФМ прошёл, а эмоции от каждого дня глубоко внутри! Я была волонтером, и моя история успеха состоит из людей, которых я повстречала на Фестивале, которым я помогала и которые помогали мне! До сих пор общаемся, хоть и прошло 5 месяцев, пишем друг другу, поздравляем с важными событиями в жизни, просто болтаем!",
      en: "The WYF has passed, but the emotions that we got every day are kept deep inside! I was a volunteer and my success story consists of people that I met at the Festival who I helped and who helped me! We still keep in touch, even 5 months later, we text, congratulate one another on important life events and just chat!",
    },
    photo: `${IMG_BASE}/darya-guskova.webp`,
  },
  {
    name: {
      ru: "Патрисия Калинга",
      en: "Patricia Kalinga",
    },
    location: {
      ru: "Замбия",
      en: "Patricia Kalinga, Zambia",
    },
    text: {
      ru: "Для меня, как участницы, представлявшей Замбию на Всемирном фестивале молодёжи, было честью общаться с многогранными молодыми лидерами и новаторами со всего мира. Я всегда буду дорожить этими моментами. А на фото со мной – Чебурашка, который стал символом дружбы в России.",
      en: "For me, as a representative of Zambia at the World Youth Festival, it was an honor to communicate with versatile young leaders and innovators from across the world. I will always cherish these moments. And in this photo, you can see me with Cheburashka that became a symbol of friendship in Russia.",
    },
    photo: `${IMG_BASE}/patricia-kalinga.webp`,
  },
  {
    name: {
      ru: "Зо Эвина Жан-Стив Эви",
      en: "Zo Evina Jean-Steve Evy",
    },
    location: {
      ru: "Камерун",
      en: "Cameroon",
    },
    text: {
      ru: "Всемирный фестиваль молодёжи стал одним из самых важных событий в моей жизни. Эта поездка позволила мне открыть для себя одну из стран моей мечты – Россию. ВФМ дал мне возможность познакомиться с молодыми людьми со всего мира, поделиться с ними незабываемыми впечатлениями и наладить партнёрские отношения для поддержки проектов моей молодёжной ассоциации в Камеруне.",
      en: "The World Youth Festival was one of the most important events in my life. This trip allowed me to discover one of the countries of my dreams – Russia. The WYF gave me an opportunity to meet young people from around the world, share unforgettable impressions with them and build partnerships to support the projects of my youth association in Cameroon.",
    },
    photo: `${IMG_BASE}/zo-evina-jean-steve-evy.webp`,
  },
  {
    name: {
      ru: "Абдулла Аль Араф",
      en: "Abdullah Al Araf",
    },
    location: {
      ru: "Бангладеш",
      en: "Bangladesh",
    },
    text: {
      ru: "Я участвовал в Фестивале как инноватор из Бангладеш, и этот опыт многое в моей жизни изменил. Я получил возможность представить свою страну на международной арене, продемонстрировав свои разработки, которые я создаю уже шесть лет для решения глобальных проблем в сфере сельского хозяйства и изменении климата. Фестиваль стал идеальной платформой, чтобы подчеркнуть значение моей работы.",
      en: "I took part at the Festival as an innovator from Bangladesh and this experience changed a lot in my life. I got the opportunity to represent my country on the international stage by demonstrating my projects, which I have been creating for six years to solve global problems in the field of agriculture and climate change. The festival has become an ideal platform to highlight the importance and impact of my work.",
    },
    photo: `${IMG_BASE}/abdullah-al-araf.webp`,
  },
  {
    name: {
      ru: "Мария Иванова",
      en: "Maria Ivanova",
    },
    location: {
      ru: "Россия, Севастополь",
      en: "Russia, Sevastopol",
    },
    text: {
      ru: "Участие в Всемирном фестивале молодёжи в качестве волонтёра стало для меня бесценным опытом, который открыл множество возможностей для личного и профессионального роста. В результате этот опыт не только укрепил мою приверженность добровольческой деятельности, но и подарил мне множество новых знакомств и друзей! Я вернулась домой с новыми идеями и мотивацией продолжать развивать волонтёрскую деятельность.",
      en: "Participation in the World Youth Festival as a volunteer was an invaluable experience for me that opened up lots of opportunities for personal and professional growth. As a result, this experience not only strengthened my commitment to volunteering, but also gave me numerous new connections and friends! I came back home with new ideas and motivation to continue developing volunteer work.",
    },
    photo: `${IMG_BASE}/maria-ivanova.webp`,
  },
  {
    name: {
      ru: "Мухаммад Джубайер Хоссаин",
      en: "Muhammad Jubayer Hossain",
    },
    location: {
      ru: "Бангладеш",
      en: "Bangladesh",
    },
    text: {
      ru: "Участие во Всемирном фестивале молодёжи – 2024 стало особенным моментом в моей жизни. Встречи с людьми из разных стран, культурный обмен и участие в региональной программе помогли мне взглянуть на мир по-новому. Этот опыт подарил мне новые идеи и мотивацию для дальнейшей работы, где я стремлюсь создавать полезные цифровые решения для людей. ВФМ объединил не только страны: он объединил людей, идеи и мечты. Вдохновленный этим путешествием, я написал книгу под названием «Мои 18 дней в России», в которой поделился воспоминаниями, которые сформировали моё мышление и цели на будущее.",
      en: "Participating in the World Youth Festival 2024 was a truly special moment in my life. Meeting people from different countries, engaging in cultural exchange, and taking part in the regional program helped me see the world from a new perspective. This experience gave me fresh ideas and motivation for my future work, where I strive to create meaningful digital solutions for people. The WYF brought together not only countries, but also people, ideas, and dreams. Inspired by this journey, I wrote a book titled «My 18 Days in Russia», sharing the memories that shaped my mindset and future goals.",
    },
    photo: `${IMG_BASE}/jubayer-hossain.webp`,
  },
]
